import React from "react";
import {
    Button,
    Icon,
    Grid,
    Dropdown,
    Header,
    Modal,
    Message,
    Container,
    Divider,
    Progress,
    MessageHeader,
} from "semantic-ui-react";
import {databaseOptions} from "../../Options/DatabaseOptions";
import ListAllSoundsPage from "../Sounds/ListAllSoundsPage";
import '../../style.css'
import ListAllPicturesPage from "../Pictures/ListAllPicturesPage";
import {ActionOptions} from "../../Options/Actions";
import {MediaOptions} from "../../Options/SoundsAndPictures";
import {classOptions} from "../../Options/ClassLevelOptions";
import {StatisticOptions} from "../../Options/StatisticOptions";

function AdminSideMenu(
    {
        handleSideMenu,
        databaseChoice,
        handleSetDatabaseChoice,
        actionChoice,
        handleSetAction,
        mediaChoice,
        handleSetMediaChoice,
        classLevel,
        handleClassLevel,
        assignment,
        handleSetAssignment,
        fileNames,
        deleteModal,
        handleDeleteModal,
        handleDeleteAssignment,
        deleteMsg,
        handleEditAssignment,
        loading,
        progress,
        editAssignmentLoading,
        editAssignmentProgress,
        statisticChoice,
        handleStatisticChoice,
        handleShowDirections,
        showDirections
    }
) {

    return (
        <>
            <div className='sideMenu'>
                <Button color='red' style={{marginLeft: 5, marginTop: 5}} onClick={handleSideMenu} icon>
                    <Icon name='x'/>
                </Button>
                <Grid centered={true}>

                    <Grid.Row className='menuTitle'>
                        <Container style={{marginTop: 10}}>
                            <Grid.Row>

                                <Button color='orange' onClick={handleShowDirections} icon>
                                    <Grid.Row>
                                        Directions
                                    </Grid.Row>
                                    <Grid.Row>
                                        {
                                            showDirections ?
                                                <Icon name='arrow up'/>
                                                :
                                                <Icon name='arrow down'/>
                                        }
                                    </Grid.Row>
                                </Button>
                            </Grid.Row>
                            {
                                showDirections ?
                                    <Message className='menuDirections'>
                                        <MessageHeader>Directions</MessageHeader>
                                        <p>
                                            <b>Database</b><br/>
                                            Use the dropdowns provided to select a page to add, edit, or delete
                                            assignments.<br/>
                                            (You may also search through the sounds/pictures to download while adding or
                                            editing
                                            assignments.)<br/><br/>
                                            <b>Action</b><br/>
                                            You may add, edit, or delete assignments based on the page you selected in
                                            the
                                            database.<br/><br/>
                                            <b>Class</b><br/>
                                            Select the class that you would like to add, edit, or delete assignments
                                            from.<br/><br/>
                                            <b>Assignments</b><br/>
                                            When selecting edit or delete under Actions, a dropdown of assignments for
                                            the page
                                            and class that you selected will be displayed here.<br/>
                                            Select an assignment, then click on the edit or delete button.<br/>
                                        </p>
                                    </Message>
                                    :
                                    null
                            }

                        </Container>
                    </Grid.Row>
                    <Divider/>
                    <Grid.Row>

                        <Header as='h1' textAlign='center'>
                            Database
                        </Header>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                        <Dropdown
                            options={databaseOptions}
                            value={databaseChoice}
                            selection
                            style={{marginRight: 10}}
                            onChange={handleSetDatabaseChoice}
                        />
                        <Dropdown
                            options={MediaOptions}
                            value={mediaChoice}
                            placeholder='None'
                            selection
                            onChange={handleSetMediaChoice}
                        />
                    </Grid.Row>
                </Grid>
                {
                    mediaChoice === 'sounds' ?
                        <ListAllSoundsPage/>
                        :
                        mediaChoice === 'pictures' ?
                            <ListAllPicturesPage/>
                            :

                            databaseChoice === 'pronunciationAssignments' || databaseChoice === 'translationFCAssignments'
                            || databaseChoice === 'dialogFCAssignments' || databaseChoice === 'dialogAssignments'
                            || databaseChoice === 'quizAssignments' ?
                                <>
                                    <Grid centered={true}>
                                        <Grid.Row>
                                            <Header as='h1' textAlign='center'>
                                                Action
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Dropdown
                                                options={ActionOptions}
                                                value={actionChoice}
                                                selection
                                                style={{marginRight: 10}}
                                                onChange={handleSetAction}
                                            />
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h1' textAlign='center'>
                                                Class
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Dropdown
                                                options={classOptions}
                                                value={classLevel}
                                                selection
                                                onChange={handleClassLevel}
                                            />
                                        </Grid.Row>
                                    </Grid>
                                    {
                                        actionChoice === 'delete' || actionChoice === 'edit' ?
                                            <Grid centered={true}>
                                                <Grid.Row>
                                                    <Header as='h1' textAlign='center'>
                                                        Assignment
                                                    </Header>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Dropdown
                                                        options={fileNames}
                                                        value={assignment}
                                                        selection
                                                        onChange={handleSetAssignment}
                                                    />
                                                </Grid.Row>
                                                {
                                                    actionChoice === 'delete' ?
                                                        <Modal
                                                            onClose={handleDeleteModal}
                                                            onOpen={handleDeleteModal}
                                                            open={deleteModal}
                                                            trigger={assignment ?
                                                                <Button color='red'>Delete Assignment</Button> :
                                                                <Button disabled color='red'>Delete Assignment</Button>}
                                                        >
                                                            <Modal.Header>Delete Assignment</Modal.Header>
                                                            <Modal.Content image>
                                                                <Modal.Description>
                                                                    <Header>You are attempting to
                                                                        delete {assignment}</Header>
                                                                    <p>
                                                                        Are you sure?
                                                                    </p>
                                                                </Modal.Description>
                                                            </Modal.Content>
                                                            <Modal.Actions>
                                                                <Button color='red' onClick={() => {
                                                                    handleDeleteModal();
                                                                    handleDeleteAssignment();
                                                                }}>
                                                                    Yes, Delete
                                                                </Button>
                                                                <Button
                                                                    content="No"
                                                                    onClick={handleDeleteModal}
                                                                    color='black'
                                                                />
                                                            </Modal.Actions>
                                                        </Modal>
                                                        :

                                                        assignment ?
                                                            <Button color='blue' onClick={()=>{handleEditAssignment(); handleSideMenu()}}>Edit
                                                                Assignment</Button>
                                                            :
                                                            <Button color='blue' disabled>Edit Assignment</Button>


                                                }
                                            </Grid>

                                            :
                                            null}

                                </>

                                :
                                null

                }
                <br/>
                <br/>
                {
                    editAssignmentLoading ?
                        <Grid centered={true}>
                            <Progress progress indicating percent={editAssignmentProgress} style={{width: 100}}/>
                        </Grid>
                        :
                        null
                }
                {
                    loading ?
                        <Grid centered={true}>
                            <Progress progress indicating percent={progress} style={{width: 100}}/>
                        </Grid>
                        :
                        null
                }
                {
                    deleteMsg ?
                        <Grid centered={true}>
                            <Message style={{width: 300}}>
                                <Message.Header>
                                    {deleteMsg}
                                </Message.Header>
                            </Message>
                        </Grid>
                        :
                        null
                }
                {
                    databaseChoice === 'statistics' ?
                        <Grid centered={true}>

                            <Grid.Row>
                                <Header as='h1' textAlign='center'>Student Data</Header>
                            </Grid.Row>
                            <Dropdown
                                options={StatisticOptions}
                                value={statisticChoice}
                                selection
                                onChange={handleStatisticChoice}
                            />
                            {
                                statisticChoice !== 'statistics' ?
                                    <>
                                        <Grid.Row>
                                            <Header as='h1' textAlign='center'>
                                                Class
                                            </Header>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Dropdown
                                                options={classOptions}
                                                value={classLevel}
                                                selection
                                                onChange={handleClassLevel}
                                            />
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Header as='h1' textAlign='center'>Assignment</Header>
                                        </Grid.Row>
                                        <Dropdown
                                            options={fileNames}
                                            value={assignment}
                                            selection
                                            onChange={handleSetAssignment}
                                        />
                                    </>
                                    :
                                    null
                            }

                        </Grid>
                        :
                        null
                }
            </div>

        </>
    )
}

export default AdminSideMenu
